function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 32,
  cy: 32,
  r: 32,
  fill: "url(#paint0_linear_2927_11896)"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M20.2508 21.9943L18.4617 19.255C18.2397 18.915 17.7603 18.915 17.5383 19.255L15.7492 21.9943C15.6763 22.1059 15.5688 22.1876 15.4449 22.2257L12.4021 23.1601C12.0245 23.276 11.8764 23.7531 12.1168 24.0792L14.0537 26.7064C14.1326 26.8134 14.1736 26.9457 14.1699 27.0808L14.0789 30.3974C14.0676 30.8091 14.4554 31.1039 14.826 30.9654L17.812 29.8498C17.9336 29.8044 18.0664 29.8044 18.188 29.8498L21.174 30.9654C21.5446 31.1039 21.9324 30.8091 21.9211 30.3974L21.8301 27.0808C21.8264 26.9457 21.8674 26.8134 21.9463 26.7064L23.8832 24.0792C24.1236 23.7531 23.9755 23.276 23.5979 23.1601L20.5551 22.2257C20.4312 22.1876 20.3237 22.1059 20.2508 21.9943Z",
  fill: "#3F8348"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M48.2508 21.9943L46.4617 19.255C46.2397 18.915 45.7603 18.915 45.5383 19.255L43.7492 21.9943C43.6763 22.1059 43.5688 22.1876 43.4449 22.2257L40.4021 23.1601C40.0245 23.276 39.8764 23.7531 40.1168 24.0792L42.0537 26.7064C42.1326 26.8134 42.1736 26.9457 42.1699 27.0808L42.0789 30.3974C42.0676 30.8091 42.4554 31.1039 42.826 30.9654L45.812 29.8498C45.9336 29.8044 46.0664 29.8044 46.188 29.8498L49.174 30.9654C49.5446 31.1039 49.9324 30.8091 49.9211 30.3974L49.8301 27.0808C49.8264 26.9457 49.8674 26.8134 49.9463 26.7064L51.8832 24.0792C52.1236 23.7531 51.9755 23.276 51.5979 23.1601L48.5551 22.2257C48.4312 22.1876 48.3237 22.1059 48.2508 21.9943Z",
  fill: "#3F8348"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M12 38C20.3333 40 37 42.5 52 38C50.5 43.8333 44.6 55.5 33 55.5C18.5 55.5 13.5 45.5 12 38Z",
  fill: "#3F8348"
});

var _ref6 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear_2927_11896",
  x1: 33.7246,
  y1: 48.5,
  x2: 33.7246,
  y2: 0,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#66CB65"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#9CF39B"
})));

var Svg0Day = function Svg0Day(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(Svg0Day, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/0day.3c451c1f.svg";
export { ForwardRef as ReactComponent };